import locales from '@spa/shared/constants/locales';
import { OFFER_UNIT_TYPE } from '@spa/shared/constants/typology';
import { translationFromLocale } from './';

export const OFFER_ORDER = {
  apartment: 1,
  studio: 2,
  bedroom: 3,
  'single-bed': 4,
  'double-bed': 4,
  'not-sold-out': 5,
  'sold-out': 6
};

export const getOfferTitleFromLanguage = ({ title }, language = 'en') => {
  const locale = locales[language.toUpperCase()];

  return translationFromLocale(title || [], locale);
};

export const getAmount = ({
  accommodation_offer: {
    reference_price: { amount }
  }
}) => parseInt(amount, 10);

export const getUnitTypeByOfferProperty = (property, offer) => {
  const type = OFFER_UNIT_TYPE[offer.property?.unit_type] || OFFER_UNIT_TYPE.apartment;
  const isSoldOut = !property.is_sold_out && offer.is_sold_out;

  return {
    ...type,
    ...(isSoldOut ? { offerType: `soldout_${type.offerType}` } : {}),
    isSoldOut
  };
};

export const orderOffers = offers => {
  return offers.slice().sort(({ accommodation_offer: a }, { accommodation_offer: b }) => {
    const aSoldOutWeight = getSoldOutOfferWeight(a.availabilities);
    const bSoldOutWeight = getSoldOutOfferWeight(b.availabilities);

    const order =
      (aSoldOutWeight || Number.MAX_VALUE) -
      (bSoldOutWeight || Number.MAX_VALUE) +
      (OFFER_ORDER[a.property.unit_type] || Number.MAX_VALUE) -
      (OFFER_ORDER[b.property.unit_type] || Number.MAX_VALUE);

    if (order === 0) {
      return orderByPrice(a.reference_price, b.reference_price);
    }

    return order;
  });
};

const getSoldOutOfferWeight = availabilities => {
  if (!availabilities.fixed && !availabilities.fixed_unitary) {
    return null;
  }

  return (availabilities.fixed && availabilities.fixed.options.every(option => option.status === 'none')) ||
    (availabilities.fixed_unitary && availabilities.fixed_unitary.options.every(option => option.status === 'none'))
    ? OFFER_ORDER['sold-out']
    : OFFER_ORDER['not-sold-out'];
};

export const orderByPrice = (priceA, priceB) => (parseInt(priceA.amount, 10) < parseInt(priceB.amount, 10) ? -1 : 1);

export const orderOffersByPrice = offers =>
  offers.sort((offerA, offerB) =>
    offerA.type === 'residences'
      ? orderByPrice(
          offerA.attributes.offers[0].accommodation_offer.price,
          offerB.attributes.offers[0].accommodation_offer.price
        )
      : orderByPrice(offerA.attributes.accommodation_offer.price, offerB.attributes.accommodation_offer.price)
  );

export const getOfferDescriptionFromLanguage = ({ description }, language = 'en') => {
  const locale = locales[language.toUpperCase()];

  return translationFromLocale(description || [], locale);
};
